import { useQuery } from '@tanstack/react-query';
import { getBranches, supportQueryKeys } from '../../api';
import { SelectOption } from '../../types/option';

export type UseBranchOptionsResult = {
  options: SelectOption[];
  loading: boolean;
  error: string | undefined;
};

export function useBranchOptions(): UseBranchOptionsResult {
  const { data, isLoading, isError } = useQuery({
    queryKey: supportQueryKeys.branches,
    queryFn: ({ signal }) => getBranches(signal),
  });

  return {
    options: data ?? [],
    loading: isLoading,
    error: isError ? 'Não foi possível carregar as lojas' : undefined,
  };
}
